// @flow

import React, { Component, Fragment } from 'react';
import { Modal } from 'clark-styles';

type StateType = {
  showModal: boolean,
};

type PropsType = {
  modalContentLabel: string,
  renderModalContent: any,
  renderModalTrigger: any,
};

class ModalAndTrigger extends Component<PropsType, StateType> {
  state = {
    showModal: false,
  };

  toggleModal = () => {
    this.setState(({ showModal }) => ({ showModal: !showModal }));
  };

  render() {
    const { modalContentLabel, renderModalContent, renderModalTrigger } = this.props;
    const { showModal } = this.state;

    return (
      <Fragment>
        {renderModalTrigger(this.toggleModal)}
        <Modal
          isOpen={showModal}
          onRequestClose={this.toggleModal}
          contentLabel={modalContentLabel}
        >
          {renderModalContent(this.toggleModal)}
        </Modal>
      </Fragment>
    );
  }
}

export default ModalAndTrigger;



// WEBPACK FOOTER //
// ./src/containers/modal-and-trigger/index.js